/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TickerAuctioneerLotStateDto } from '../../models/ticker-auctioneer-lot-state-dto';

export interface GetTickerAuctioneerLotState$Params {
  id: number;
  'X-API-Version'?: string;
}

export function getTickerAuctioneerLotState(http: HttpClient, rootUrl: string, params: GetTickerAuctioneerLotState$Params, context?: HttpContext): Observable<StrictHttpResponse<TickerAuctioneerLotStateDto>> {
  const rb = new RequestBuilder(rootUrl, getTickerAuctioneerLotState.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.header('X-API-Version', params['X-API-Version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TickerAuctioneerLotStateDto>;
    })
  );
}

getTickerAuctioneerLotState.PATH = '/api/ticker/lot-auctioneer-states/{id}';
